export default __webpack_public_path__ + "static/media/2425 utensils top.4c7636b2.png";